import { useEffect } from 'react';

import { useCheckFlag } from 'hooks/useCheckFlag';
import { useGetServiceBr } from 'queries';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';

import { ControlledSelect } from 'components/shared';
import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';
import { GridCompact12 } from 'components/shared/Grid/Grid.components';

export default function ServiceBrSection() {
  const { t } = useTranslation();
  const { data: serviceBrOptions } = useGetServiceBr();
  const { control, setValue } = useFormContext();

  const isReqFlagContained = useCheckFlag(`flags`, 'SERVICE_BR_DEFAULT_FLAG');

  useEffect(() => {
    if (isReqFlagContained) {
      setValue(`serviceBrId`, null);
    }
  }, [isReqFlagContained]);

  return (
    <Grid container>
      <GridCompact12>
        <ControlledFlagCheckbox
          flag="SERVICE_BR_DEFAULT_FLAG"
          name={`flags`}
          label={t('surchargesMaintenance.form.flags.SERVICE_BR_DEFAULT_FLAG')}
        />
      </GridCompact12>
      <GridCompact12>
        <ControlledSelect
          control={control}
          name="serviceBrId"
          variant="outlined"
          label={t('surchargesMaintenance.form.serviceBrId')}
          options={(isReqFlagContained ? [] : serviceBrOptions) ?? []}
        />
      </GridCompact12>
    </Grid>
  );
}
